<div class="search-holder">
    <dialog class="dialog p-shadow-6" [class.slide]="dialogOpen" open>
        <div class="search-bar-container">
            <i class="pi pi-spin pi-spinner-dotted waiting-icon" [class.hide]="!isProcessing"></i>
            <input type="text" id="inputElement" class="search-bar" [(ngModel)]="searchText" [tabindex]="dialogOpen ? 1 : -1" (input)="textChanged($event.target)" placeholder="Ara" #searchBar>
        </div>
        
        <div class="brand-text">powered by İdeabilisim</div>
        
        <div class="list-container" [class.slow-growth]="datas.length > 0">
            
            <ng-container *ngFor="let item of datas; let index = index" [ngSwitch]="item.type">

                <app-search-case-card *ngSwitchCase="'case'" [index]="index" [data]="item" [openInNewPage]="settings.openInNewPage" (onPinItem)="pinItem($event.item, $event.index)" (onCloseDialog)="closeDialog()"></app-search-case-card>
                <app-search-case-card *ngSwitchCase="'appointment'" [index]="index" [data]="item" [openInNewPage]="settings.openInNewPage" (onPinItem)="pinItem($event.item, $event.index)" (onCloseDialog)="closeDialog()"></app-search-case-card>

                <app-search-organization-card *ngSwitchCase="'organization'" [index]="index" [data]="item" [openInNewPage]="settings.openInNewPage" (onPinItem)="pinItem($event.item, $event.index)" (onCloseDialog)="closeDialog()"></app-search-organization-card>

                <app-search-patient-file-card *ngSwitchCase="'patientFiles'" [index]="index" [data]="item"
                    [openInNewPage]="settings.openInNewPage" (onPinItem)="pinItem($event.item, $event.index)"
                    (onCloseDialog)="closeDialog()"></app-search-patient-file-card>
            </ng-container>
        
        </div>
    
        <div class="side-section">
            
            <p-button icon="pi pi-cog" pTooltip="Ayarlar Menüsü" tabindex="-1" [severity]="openConfig ? 'info' : 'primary'" styleClass="p-button-sm" tooltipPosition="top" (onClick)="openConfig = !openConfig; toggleConfigPanel($event)"></p-button>
            <p-button icon="pi pi-times" pTooltip="Kapat" tabindex="-1" styleClass="p-button-sm p-button-danger" tooltipPosition="top" (onClick)="closeDialog()"></p-button>
            
            <app-search-settings #searchSettings [settings]="settings"></app-search-settings>
    
        </div>
    
        <div class="pinned-panel p-shadow-6">
            <div class="pinned-panel-control" [class.open]="pinnedOpen">
                <b>Favoriler</b>
                <p-button [icon]="'pi pi-'+(pinnedOpen ? 'angle-up' : 'angle-down')" tabindex="-1" [badge]="pinnedItems.length.toString()" [text]="true" size="small" label=" " (onClick)="togglePinnedPanel()"></p-button>
            </div>
    
            <div class="list-container" [class.slow-growth]="pinnedOpen">

                <ng-container *ngFor="let item of pinnedItems; let index = index" [ngSwitch]="item.type">

                    <app-search-case-card *ngSwitchCase="'case'" [index]="index" [data]="item" [openInNewPage]="settings.openInNewPage" [pinned]="true" (onUnpinItem)="unpinItem($event)" (onCloseDialog)="closeDialog()"></app-search-case-card>
                    <app-search-case-card *ngSwitchCase="'appointment'" [index]="index" [data]="item" [openInNewPage]="settings.openInNewPage" [pinned]="true" (onUnpinItem)="unpinItem($event)" (onCloseDialog)="closeDialog()"></app-search-case-card>

                    <app-search-organization-card *ngSwitchCase="'organization'" [index]="index" [data]="item" [openInNewPage]="settings.openInNewPage" [pinned]="true" (onUnpinItem)="unpinItem($event)" (onCloseDialog)="closeDialog()"></app-search-organization-card>

                       <app-search-patient-file-card *ngSwitchCase="'patientFiles'"[index]="index" [data]="item" [openInNewPage]="settings.openInNewPage" [pinned]="true" (onUnpinItem)="unpinItem($event)" (onCloseDialog)="closeDialog()"></app-search-patient-file-card>
                </ng-container>

            </div>

            <div *ngIf="pinnedItems.length === 0 && pinnedOpen" class="empty-list-text">Burası boş :(</div>

        </div>
    
    </dialog>
</div>

<div class="background-hider" [class.hide-active]="settings.hideBackground && dialogOpen"></div>